@if (headerTitle || activeTab) {
  <div class="am-flex-align gap-auto header-title-wrapper">
    @if (activeTab?.counter) {
      @if (loading) { <span class="width-40 height-40 width-mobile-xxxl height-mobile-xxxl loading-animate"></span> }
      @else         { <span class="am-flex-center p-xs font-icon p-xxs-mobile b-radius color-white" [ngClass]="['bg-'+activeTab.color, activeTab.icon]"></span> }
    }
    <span class="flex-column color-title-grey">
      <h1 class="font-500 text-xl mobile-hide" [ngClass]="loading ? 'color-transparent loading-animate' : ''">{{ headerTitle || activeTab.dashboardTitle }}</h1>
      <h1 class="font-500 text-l  mobile-show" [ngClass]="loading ? 'color-transparent loading-animate' : ''">{{ headerTitle || activeTab.mobileTitle || activeTab.dashboardTitle }}</h1>
    </span>
  </div>
}

<div class="am-flex-justify-end am-flex-wrap-reverse am-flex-1 gap-auto">
  @if (filters || togglers || dropdowns) {
    <div class="am-flex-align am-flex-1 gap-auto export-btn-group mobile-hide">
      @if (dropdowns) { <ng-container *ngTemplateOutlet="dropdownsTemplate; context: { dropdowns: dropdownsByUserRole, loading }"></ng-container> }
      @if (togglers ) { <ng-container *ngTemplateOutlet="togglersTemplate; context:  { togglers:  togglersByUserRole,  loading }"></ng-container> }
      @if (filters  ) { <ng-container *ngTemplateOutlet="filtersTemplate;  context:  { filters:   filtersByUserRole,   loading }"></ng-container> }
    </div>
  }

  @if (downloadAvailable || printAvailable || excelAvailable || reloadAvailable || button) {
    <div class="am-flex-align gap-auto export-btn-group width-mobile-full am-flex-mobile-justify-end">
      @if (excelAvailable) {
        <div class="am-flex-center custom-button button-white width-120 width-mobile-auto-i hover-active pl-xs pr-xs gap-xs" [ngClass]="loading ? 'loading-animate b-radius-wide-i' : ''" (click)="excel.emit()" [class.disabled]="!entriesLength || disableExcel">
          <span [class.color-transparent-i]="loading" class="am-flex-center font-icon icon-download"></span>
          <span [class.color-transparent-i]="loading" class="text-m mobile-hide">Export</span>
        </div>
      }
      @if (downloadAvailable) {
        <div class="am-flex-center multi-button width-mobile-auto-i b-radius overflow" [ngClass]="loading ? 'loading-animate b-radius-wide-i' : ''" [class.disabled]="!entriesLength || disablePrint">
          <span class="am-flex-center height-full pl-xs pr-xs width-mobile-auto-i width-120 hover-active gap-xs font-s" [class.b-none-i]="loading" (click)="download.emit()">
            <span [class.color-transparent-i]="loading" class="am-flex-center font-icon width-30 width-mobile-full icon-download"></span>
            <span [class.color-transparent-i]="loading" class="text-m mobile-hide">Download</span>
          </span>
          @if (!loading && enableDownloadExtra) {
            <span class="am-flex-center height-full active hover-active pl-xs pr-xs icon-dots" (click)="downloadExtra.emit()"></span>
          }
        </div>
      }
      @if (printAvailable) {
        <div class="am-flex-center multi-button width-mobile-auto-i" [ngClass]="loading ? 'loading-animate b-radius-wide-i overflow' : ''" [class.disabled]="!loading && (!entriesLength || disablePrint)">
          <span class="am-flex-center height-full pl-xs pr-xs width-mobile-auto-i width-120 hover-active gap-xs font-s" [class.b-none-i]="loading" (click)="print.emit()">
            <span [class.color-transparent-i]="loading" class="am-flex-center font-icon width-30 width-mobile-full icon-print"></span>
            <span [class.color-transparent-i]="loading" class="text-m mobile-hide">Drucken</span>
          </span>
          @if (!loading && enablePrintExtra) {
            <span class="am-flex-center height-full active hover-active pl-xs pr-xs icon-dots" (click)="printExtra.emit()"></span>
          }
        </div>
      }
      @if (button) {
        <div class="am-flex-center custom-button button-blue archive-form-button gap-xs hover-active" (click)="buttonCallback.emit()">
          <span [ngClass]="button.icon" class="am-flex-center font-icon"></span>
          <span class="font-m">{{ button.label }}</span>
        </div>
      }
      @if (reloadAvailable) {
        <div (click)="reloadHandler()"
              class="am-flex-center custom-button pl-xs pr-xs gap-xs tooltip-icon overflow-visible-i"
             [ngClass]="{ 'b-orange':                  sessionStorageService.reloadAvailable,
                          'b-grey hover-active-blue': !sessionStorageService.reloadAvailable,
                          'loading-animate b-radius-wide-i': loading}">
          <span [class.color-transparent-i]="loading" class="am-flex-center font-icon icon-reload" [ngClass]="sessionStorageService.reloadAvailable ? 'color-orange hover-active' : ''"></span>
          @if (sessionStorageService.reloadAvailable) {
            <div class="web-tooltip orange-border medium left">
              <span class="font-s">Changes available, click to reload</span>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

@if (togglers || filters || dropdowns) {
  <div class="am-flex-align am-flex-justify width-full gap-m export-btn-group mobile-show">
    @if (filters)   { <ng-container *ngTemplateOutlet="filtersTemplate;   context: { filters:   filtersByUserRole,   mobile: true }"></ng-container> }
    @if (togglers)  { <ng-container *ngTemplateOutlet="togglersTemplate;  context: { togglers:  togglersByUserRole,  mobile: true }"></ng-container> }
    @if (dropdowns) { <ng-container *ngTemplateOutlet="dropdownsTemplate; context: { dropdowns: dropdownsByUserRole, mobile: true }"></ng-container> }
  </div>
}

<ng-template #filtersTemplate let-filters="filters" let-mobile="mobile" let-loading="loading">
  <div class="am-flex-align am-flex-justify-start gap-s">
    @for (filter of filters; track filter) {
      <span class="pl-xs pr-xs pt-xxs pb-xxs" (click)="filtersChanged.emit(filter.field)"
           [class.bg-blue]="    !loading && filter.active"
           [class.color-white]="!loading && filter.active"
           [ngClass]="(mobile  ? 'am-flex-center font-icon '+filter.icon : 'am-flex-align gap-xs') + ' ' +
                     (loading ? 'loading-animate color-transparent b-none-i' : 'b-grey')">
        @if (!mobile) {
          <span class="am-flex-center font-icon" [ngClass]="filter.icon"></span>
          <span class="text-s">{{ filter.label }}</span>
        }
      </span>
    }
  </div>
</ng-template>

<ng-template #togglersTemplate let-togglers="togglers" let-mobile="mobile" let-loading="loading">
  <div class="am-flex-align am-flex-justify-end multi-button" #toggler [ngClass]="loading ? 'mla loading-animate b-radius-wide-i overflow' : 'width-full'">
    @for (toggler of togglers; track toggler) {
      <span class="am-flex-center height-full hover-active gap-xs gap-xxs-tablet toggler-tab font-s"
           [ngClass]="(mobile ? 'am-flex-1' : 'pl-xs pr-xs pl-xxs-tablet pr-xxs-tablet') + ' ' + (loading ? 'color-transparent b-none-i' : 'bg-white')"
           [class.active]="!loading && toggler.active"
           (click)="(togglersAllowToDisable || !toggler.active) && togglersChanged.emit(toggler.value)">
        @if ( toggler.icon               ) { <span [class.color-white-i]="!loading && toggler.active" [ngClass]="toggler.icon" class="am-flex-center font-icon"></span> }
        @if (!toggler.labelMin || !mobile) { <span [class.display-flex-i]="button" >{{ enoughSpace ? toggler.label : (toggler.labelMin || toggler.label) }}</span>      }
      </span>
    }
  </div>
</ng-template>

<ng-template #multiStatetogglersTemplate let-label="label" let-field="field" let-togglers="togglers" let-mobile="mobile" let-loading="loading">
  <div class="am-flex-align gap-s">
    @if (label) { <span class="text-s color-secondary-grey" [class.width-90]="mobile" [ngClass]="loading ? 'loading-animate color-transparent' : ''">{{ label }}</span> }
    <div class="am-flex-align p-xxs b-grey" [ngClass]="(mobile ? 'am-flex-1 am-flex-justify width-full' : '') + ' ' + (loading ? 'loading-animate overflow' : '')">
      @for (toggler of togglers; track toggler.value) {
        <span class="am-flex-center height-full b-radius hover-active gap-xs pl-xs pr-xs pt-xxs pb-xxs font-s word-no-wrap"
             [ngClass]="loading ? 'color-transparent b-none-i' : ''"
             [class.am-flex-1]="mobile"
             [class.am-flex-center]="mobile"
             [class.color-blue]="!loading && toggler.active"
             (click)="togglersChanged.emit({ field, subfield: toggler.value })">
          <span>{{ toggler.label }}</span>
        </span>
      }
    </div>
  </div>
</ng-template>

<ng-template #dropdownsTemplate let-dropdowns="dropdowns" let-mobile="mobile" let-loading="loading">
  <div class="gap-s dropdown-wrapper" [ngClass]="mobile ? 'am-flex-column width-full' : 'am-flex-wrap mla'">
    @for (dropdown of dropdowns; track dropdown) {
      <div class="am-flex-column relative">
        <div class="am-flex-align gap-xs hover-active" (click)="dropdown.collapse = !dropdown.collapse">
          <span class="font-s" [class.width-80]="mobile" [ngClass]="loading ? 'loading-animate color-transparent' : ''">{{ dropdown.label }}</span>
          <span class="am-flex-align am-flex-1 gap-xs p-xs b-grey b-radius-wide bg-white font-s" [class.width-70]="!mobile" [class.width-full]="mobile" [ngClass]="loading ? 'loading-animate color-transparent' : ''">
            <span>{{ getDropdownLabel(dropdown) }}</span>
            <span class="am-flex-center icon-arrow-down mla" [class.rotate]="dropdown.collapse"></span>
          </span>
        </div>
        @if (!loading && dropdown.collapse) {
          <div class="am-flex-column p-xs b-grey b-radius-wide bg-white absolute top-full z-1 left-0 right-0 mt-xs">
            @for (option of dropdown.options; track $index) {
              <span class="am-flex-align gap-xs hover-active" [class.color-blue]="dropdown.value === option.value" (click)="dropdownSelect(dropdown, option)">
                <span class="circle-xs" [ngClass]="dropdown.value === option.value ? 'bg-blue b-blue': 'bg-grey b-grey'"></span>
                <span class="font-s">{{ option.label }}</span>
                @if (dropdown.value === option.value) { <span class="am-flex-center icon-tick mla"></span> }
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>
